import { render, staticRenderFns } from "./validasi.vue?vue&type=template&id=f72bb252&scoped=true"
import script from "./validasi.vue?vue&type=script&lang=js"
export * from "./validasi.vue?vue&type=script&lang=js"
import style0 from "./validasi.vue?vue&type=style&index=0&id=f72bb252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72bb252",
  null
  
)

export default component.exports